import styled from 'styled-components';
import theme from 'styled-theming';
var Divider = styled.hr.withConfig({
  displayName: "Dividerstyles__Divider",
  componentId: "sc-l9v5jy-0"
})(["border:none;background:", ";flex-shrink:0;align-self:", ";"], theme('mode', {
  light: 'var(--dentsu-color-n300)',
  dark: 'var(--dentsu-color-white)'
}), function (props) {
  return props.isFlexChild ? 'stretch' : 'unset';
});
var HorizontalDivider = styled(Divider).withConfig({
  displayName: "Dividerstyles__HorizontalDivider",
  componentId: "sc-l9v5jy-1"
})(["display:block;width:", ";height:1px;margin:8px 0;"], function (props) {
  return props.isFlexChild ? 'auto' : '100%';
});
var VerticalDivider = styled(Divider).withConfig({
  displayName: "Dividerstyles__VerticalDivider",
  componentId: "sc-l9v5jy-2"
})(["display:", ";width:1px;height:", ";margin:0 8px;vertical-align:", ";"], function (props) {
  return props.isFlexChild ? 'block' : 'inline-block';
}, function (props) {
  return props.isFlexChild ? 'auto' : '100%';
}, function (props) {
  return props.isFlexChild ? 'unset' : 'middle';
});
export var Styled = {
  HorizontalDivider: HorizontalDivider,
  VerticalDivider: VerticalDivider
};